import { ComponentProps } from "react";

import { twMerge } from "tailwind-merge";

export const Cell = ({ children, className }: ComponentProps<"div">) => {
  return (
    <div
      className={twMerge(
        "border-dawnPink2 flex items-center justify-end gap-x-1.5 border-t bg-transparent px-4 py-2.5",
        className
      )}
    >
      {children}
    </div>
  );
};
